import { render, staticRenderFns } from "./RecruitmentSection.vue?vue&type=template&id=4a1cbc08&"
import script from "./RecruitmentSection.vue?vue&type=script&lang=js&"
export * from "./RecruitmentSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports